import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/pen.png'


const _withScopeId = n => (_pushScopeId("data-v-1f499ed2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"30px"},
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingPage = _resolveComponent("LoadingPage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "snap",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logBags && _ctx.logBags(...args)))
    }, [
      _hoisted_1,
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.t("recordbag")), 1)
    ]),
    _createVNode(_component_LoadingPage, {
      isLoading: _ctx.isLoading,
      tip: _ctx.t('recording')
    }, null, 8, ["isLoading", "tip"])
  ], 64))
}